// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:ojtY6w */\n.p1Fw8{display:grid;grid-template-columns:minmax(0,1fr);grid-template-rows:auto 1fr auto;min-height:100vh}._1pOou{min-height:calc(100vh - var(--header-h));padding-bottom:var(--audio-spacing-48)}._1pOou:first-child{min-height:100vh;padding-bottom:0}@media (min-width:1280px){._1pOou{padding-bottom:var(--audio-spacing-80)}._1pOou:first-child{padding-bottom:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appLayout": "p1Fw8",
	"main": "_1pOou"
};
export default ___CSS_LOADER_EXPORT___;
